const upperFirst = require("mn-utils/upperFirst");
const formatTime = require("mn-utils/formatTime");
const generatePDF = require("../../../../../utils/generatePDF");
const formatNumCurrency = require("../../../../../utils/formatNumCurrency");

module.exports = (data) => {
  const {
    invoiceNumber,
    buyerName,
    email,
    phone,
    company,
    address,
    orderId,
    hash,
    fiatAmount,
    fiatCode,
    currencyAmount,
    currencyCode,
    network,
    feeAmount,
    feeCode,
    timeOfInvoice,
    timeOfExpiration,
    desc,
    status
  } = data;

  return generatePDF([
    ['Invoice number', invoiceNumber],
    ['Buyer name', buyerName],
    ['Customer email', email || '-'],
    ['Phone', phone || '-'],
    ['Company', company || '-'],
    ['Address', address || '-'],
    ['Order ID', orderId || '-'],
    ['Transaction hash', hash || '-'],
    ['Amount (fiat)', fiatAmount ? `${formatNumCurrency(fiatAmount)} ${fiatCode}` : '-'],
    ['Amount (crypto)', currencyAmount ? `${currencyAmount} ${currencyCode}` : '-'],
    ['Network', network ? upperFirst(network) : '-'],
    ['Fee', feeAmount ? `${feeAmount} ${feeCode}` : '-'],
    [
      'Order date and time',
      timeOfInvoice
        ? formatTime(timeOfInvoice, '{dddd} {mmmm} {dd}, {yyyy} {HH}:{MM}')
        : '-',
    ],
    [
      'Due date and time',
      timeOfExpiration
        ? formatTime(timeOfExpiration, '{dddd} {mmmm} {dd}, {yyyy} {HH}:{MM}')
        : '-',
    ],
    ['Description', desc || '-'],
    {separator: true},
    ['Status', upperFirst(status)]
  ])
}
